import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class NbinputExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  public loadExcelFileAsJson(file: File): any {
    return new Promise<any>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (f => {
        // console.log('f: ',f.target.result);
        const workbook = XLSX.read(f.target['result'], {type: 'binary'});
        const result = [];
        for (const sname in workbook.Sheets) {
          if (workbook.Sheets.hasOwnProperty(sname)) {
            result.push({name: sname, data: XLSX.utils.sheet_to_json(workbook.Sheets[sname]).map(s => {
                const rr = {};
                Object.keys(s).forEach(k => rr[k.trim()] = s[k].trim());
                return rr;
              })});
          }
        }
        resolve(result);
      });
      reader.readAsBinaryString(file);
    });


  }

}
